import type { FC, ReactNode } from 'react';
import { Picture } from '@ui';
import { inputCross } from '@images';

interface ModalHeaderProps {
  title: ReactNode;
  right?: ReactNode;
  onClose?: () => void;
}

const ModalHeader: FC<ModalHeaderProps> = ({ title, right, onClose }) => {
  let rightContent = right;
  if (rightContent === undefined && onClose) {
    rightContent = (
      <span className='city'>
        <Picture icon={inputCross} height='20' alt='' onClick={onClose} />
      </span>
    );
  }

  return (
    <div className='regionTitle'>
      <span className='title'>{title}</span>
      {rightContent ?? null}
    </div>
  );
};

export default ModalHeader;
